import { render, staticRenderFns } from "./FacebookPagesCard.vue?vue&type=template&id=eb5afa02&scoped=true"
import script from "./FacebookPagesCard.vue?vue&type=script&lang=js"
export * from "./FacebookPagesCard.vue?vue&type=script&lang=js"
import style0 from "./FacebookPagesCard.vue?vue&type=style&index=0&id=eb5afa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5afa02",
  null
  
)

export default component.exports